import styled from 'styled-components'

export const SiteColContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`
